import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";
import {useNavigate} from "react-router-dom";

export default function ServiceSelection({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}){
     
    const navigate=useNavigate();

    const selectService = (service) => {
        if (loading) return;
        setError("");
        const businessLocationSlug =
            flowContext.businessLocationSlug;
        const businessTypeSlug =
            flowContext.businessTypeSlug;
        const serviceSlug =
            service.uniqueSlug;
        updateFlowContext({
            flowId: null,
            currentStep: null,
            flowStatus: null,
            waiver: null,
        });
        updateFlowData({
            service: null,
        });
        navigate(
            `/start-waiver/${businessLocationSlug}/${businessTypeSlug}/${serviceSlug}`
        );
    };

    return(
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            {flowContext.flowStatus === "NO_ACTIVE_WAIVER" && (
                <div style={{ color: "red", fontWeight: "bold" }}>
                    No Waivers Found for {flowContext.selectedService?.name}
                </div>
            )}

            <div className="page-header">
                <h2 className="business-name">
                    {flowContext.business?.businessName}
                </h2>
                <h3 className="page-title">
                    Select your waiver type
                </h3>
            </div>

            <div className="page-content">

                <div className="list">
                    {flowContext.services?.map(service=>(
                        <div
                            key={service._id}
                            className={`list-card ${loading ? "disabled" : ""}`}
                             onClick={loading ? undefined : () => selectService(service)}
                        >
                            <div className="list-icon"/>
                            <div className="list-name">
                                {service.name}
                            </div>
                            <div className="list-arrow">
                                ›
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            <div className="page-footer">
                Powered by <strong>DidYouSign</strong>
            </div>

</div>
    );
}